import React from 'react';

export const CircleCheck = (props: any) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="10 10 20 20"
    preserveAspectRatio="xMinYMin meet"
  >
    <path
      fillRule="evenodd"
      d="M19.294 12.235c1.481 0 2.88.394 4.115 1.166a.706.706 0 11-.748 1.198 6.267 6.267 0 00-3.367-.952c-3.492 0-6.353 2.86-6.353 6.353s2.86 6.353 6.353 6.353 6.353-2.86 6.353-6.353c0-.588-.066-1.165-.19-1.664a.705.705 0 111.369-.342c.154.615.233 1.306.233 2.006 0 4.272-3.493 7.765-7.765 7.765S11.53 24.272 11.53 20s3.493-7.765 7.765-7.765zm8.264.913c.26.26.275.67.046.948l-.046.05-7.765 7.765a.705.705 0 01-.948.046l-.05-.046-2.824-2.824a.707.707 0 01.948-1.044l.05.046 2.325 2.324 7.266-7.265a.705.705 0 01.998 0z"
    />
  </svg>
);
